import { ErrorMessage, Formik } from 'formik'
import { Button } from 'primereact/button'
import ConfirmationModalResendForm from '../../../components/ConfirmationModalResendForm'
import InputTextarea from '../../../components/InputTextarea'
import React, { useState } from 'react'
import { flushSync } from 'react-dom'
import axios from 'axios'
import moment from 'moment/moment'
import { useMutation } from '@apollo/client'
import { DOWNLOAD_FILE } from '../Doctors/DoctorDetail/DoctorDetail.graphql'
import { Dialog } from 'primereact/dialog'
import { Checkbox, Image } from 'antd'
import { DatePicker } from '@medical/components/MomentPickers'
import * as Yup from 'yup'
import locale from 'antd/es/date-picker/locale/ja_JP'
import UploadIdentity from '../../../components/Forms/DoctorIdentityForm/UploadIdentity'
import { ConfirmationModal } from '../../../components'
import { InputText } from 'primereact/inputtext'

export const MyCarCommutingApplicationScene = (
  {
    i18n,
    popup,
    onSubmit,
    data = []
  }) =>{
  let input = data.length === 1 ? data[0] : {}
  const [downloadFile] = useMutation(DOWNLOAD_FILE)
  const [img, setImg] = useState({ fileURL: '',key: '' })

  const downloadFileSubmit = async (key) => {
    if (!key || key.length === 0) return
    try {
      const data = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/download-file`,
        null,
        {
          params: {
            fileName:key,
          },
          responseType: 'blob',
        }
      )
      const blobURL = URL.createObjectURL(data.data)
      const a = document.createElement('a')
      a.href = blobURL
      a.style = 'display: none'
      a.download = `${key}`
      a.target = '__blank'
      document.body.appendChild(a)
      a.click()
    } catch (error) {
      popup.error(error)
    }
  }

  const downloadFileSubmit2 = async (key, callback) => {
    if (!key || key.length === 0) return
    try {
      const {
        data: { downloadFileS3: fileURL },
      } = await downloadFile({
        variables: {
          key,
        },
      })
      callback(fileURL)
    } catch (error) {
      callback(null)
    }
  }

  const validationSchema2 = Yup.object({
    frontSideLicenseKey: Yup.mixed().required(
      i18n.t('validation.myCarCommutingApplication.frontSideLicenseRequired')
    ),
    backSideLicenseKey: Yup.mixed().required(
      i18n.t('validation.myCarCommutingApplication.backSideLicenseRequired')
    ),
    expirationDate: Yup.date()
      .nullable()
      .required(
        i18n.t('validation.myCarCommutingApplication.expirationDateRequired')
      )
      .typeError(
        i18n.t('validation.myCarCommutingApplication.expirationDateRequired')
      ),
    liabilityInsuranceCertificateExpirationDate: Yup.date()
      .nullable()
      .required(
        i18n.t('validation.myCarCommutingApplication.liabilityInsuranceCertificateExpirationDateRequired')
      )
      .typeError(
        i18n.t('validation.myCarCommutingApplication.liabilityInsuranceCertificateExpirationDateRequired')
      ),
    voluntaryInsuranceCertificateExpirationDate: Yup.date()
      .nullable()
      .required(
        i18n.t('validation.myCarCommutingApplication.voluntaryInsuranceCertificateExpirationDateRequired')
      )
      .typeError(
        i18n.t('validation.myCarCommutingApplication.voluntaryInsuranceCertificateExpirationDateRequired')
      ),
    carCommuteStartDate: Yup.date()
      .nullable()
      .required(
        i18n.t('validation.myCarCommutingApplication.carCommuteStartDateRequired')
      )
      .typeError(
        i18n.t('validation.myCarCommutingApplication.carCommuteStartDateRequired')
      ),
    vehicleInspectionCertificateKey: Yup.mixed().required(
      i18n.t(
        'validation.myCarCommutingApplication.vehicleInspectionCertificateRequired'
      )
    ),
    liabilityInsuranceCertificateKey: Yup.mixed().required(
      i18n.t(
        'validation.myCarCommutingApplication.liabilityInsuranceCertificateRequired'
      )
    ),
    voluntaryInsuranceCertificateKey: Yup.mixed().required(
      i18n.t(
        'validation.myCarCommutingApplication.voluntaryInsuranceCertificateRequired'
      )
    ),
    vehicleInspectionExpirationDate: Yup.date()
      .nullable()
      .required(
        i18n.t(
          'validation.myCarCommutingApplication.vehicleInspectionExpirationDateRequired'
        )
      )
      .typeError(
        i18n.t(
          'validation.myCarCommutingApplication.vehicleInspectionExpirationDateRequired'
        )
      ),
    vehicleType: Yup.string().required(
      i18n.t('validation.myCarCommutingApplication.vehicleTypeRequired')
    ),
    licensePlateNumberPart1: Yup.string(),
    licensePlateNumberPart2: Yup.string(),
    licensePlateNumberPart3: Yup.string(),
    licensePlateNumberPart4: Yup.string()
  }).test('vehicle-number-validate', function (values) {
    const {
      licensePlateNumberPart1,
      licensePlateNumberPart2,
      licensePlateNumberPart3,
      licensePlateNumberPart4,
    } = values || {}

    const licensePlateNumberPart1Value = licensePlateNumberPart1 || '';
    const licensePlateNumberPart2Value = licensePlateNumberPart2 || '';
    const licensePlateNumberPart3Value = licensePlateNumberPart3 || '';
    const licensePlateNumberPart4Value = licensePlateNumberPart4 || '';

    if (
      licensePlateNumberPart1Value.trim().length === 0 &&
      licensePlateNumberPart2Value.trim().length === 0 &&
      licensePlateNumberPart3Value.trim().length === 0 &&
      licensePlateNumberPart4Value.trim().length === 0) {
      return this.createError({
        path: 'vehicleNumber',
        message: i18n.t('validation.myCarCommutingApplication.licensePlateNumberRequired'),
      });
    }

    if (
      !/^[^\s　]+$/.test(licensePlateNumberPart1Value) ||
      !/^[A-Za-z0-9]{3}$/.test(licensePlateNumberPart2Value) ||
      !/^[ぁ-ん]$/.test(licensePlateNumberPart3Value) ||
      !/^\d{1,4}$/.test(licensePlateNumberPart4Value)
    ){
      return this.createError({
        path: 'vehicleNumber',
        message: i18n.t(
          'validation.myCarCommutingApplication.licensePlateNumberFormat'
        ),
      })
    }

    return true;
  });

  const MyCarCommutingApplicationItem = ({ keyValue, setFieldValue, filename }) => {
    return (
      <div className='item'>
        <div className='modal-wrapper'>
          <React.Fragment>
            <Dialog
              style={{ width: 'auto', backgroundColor: 'transparent' }}
              visible={img.fileURL !== '' && img.key === keyValue}
              className='p-dialog'
              footer={
                <>
                  <Button
                    type='button'
                    label='ダウンロード'
                    onClick={() => {
                      downloadFileSubmit(img.key)
                    }}
                    icon='pi pi-cloud-download'
                    className='p-button-secondary'
                    style={{ textAlign: 'center' }}
                  />
                </>
              }
              closeOnEscape
              onHide={() => setImg({ fileURL: '', key: '' })}
            >
              <Image width={300} height={300} src={img.fileURL} />
            </Dialog>

            <div className='td-image'
                 style={{ padding: '0px', width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                className='button-preview-image-file'
                onClick={() => {
                  setFieldValue('uploadModal', true)
                  setFieldValue('currentUploadField', filename)
                }}
                label={
                (keyValue === null || keyValue === undefined || keyValue === '')
                  ? i18n.t('main.noFile') : keyValue
              }
                icon='pi pi-cloud-download'
              />
              <Button
                type='button'
                disabled={keyValue === null || keyValue === undefined || keyValue === ''}
                label={i18n.t('main.downloadFile')}
                onClick={() => {
                  previewImage(keyValue)
                }}
                icon='pi pi-cloud-download'
                className='p-button-secondary'
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    )
  }

  const previewImage = async imgKey => {
    try {
      const {
        data: { downloadFileS3: fileURL },
      } = await downloadFile({
        variables: {
          key: imgKey
        },
      })

      setImg({ fileURL: fileURL, key: imgKey })

    } catch (error) {
      popup.error(i18n.t('main.downloadFileError'))
    }
  }

  return (
    <>
      <Formik
        initialValues={{
          id: input?.id || '',
          msg: '',
          type: '',
          confirm: false,
          uploadModal: false,
          currentUploadField: '',
          isAllowSendMailConfirm: false,
          vehicleType: input?.vehicleType || '',
          expirationDate: input?.expirationDate,
          carCommuteStartDate: input?.carCommuteStartDate,
          backSideLicenseKey: input?.backSideLicenseKey || '' ,
          frontSideLicenseKey: input?.frontSideLicenseKey || '',
          licensePlateNumberPart1: input?.licensePlateNumberPart1 || '',
          licensePlateNumberPart2: input?.licensePlateNumberPart2 || '',
          licensePlateNumberPart3: input?.licensePlateNumberPart3 || '',
          licensePlateNumberPart4: input?.licensePlateNumberPart4 || '',
          vehicleInspectionExpirationDate: input?.vehicleInspectionExpirationDate,
          vehicleInspectionCertificateKey: input?.vehicleInspectionCertificateKey || '',
          liabilityInsuranceCertificateKey: input?.liabilityInsuranceCertificateKey || '',
          liabilityInsuranceCertificateExpirationDate: input?.liabilityInsuranceCertificateExpirationDate,
          voluntaryInsuranceCertificateKey: input?.voluntaryInsuranceCertificateKey || '',
          voluntaryInsuranceCertificateExpirationDate: input?.voluntaryInsuranceCertificateExpirationDate,
        }}
        validationSchema={validationSchema2}
        enableReinitialize
        onSubmit={onSubmit}
        render={formikProps =>{
          const {
            values, setFieldValue, handleSubmit, isSubmitting,
            setFieldError,validateForm,setTouched } = formikProps

          function disabledPastDate(current) {
            return (
              current &&
              current <
              moment()
                .subtract(1, 'days')
                .endOf('day')
            )
          }

          return (
            <React.Fragment>
              <div className='my-car-commuting-info-container'>
                <div className='my-car-commuting-info-content'>
                  {
                    input?.doctor && (
                      <>
                        <div className='item text-bold'>医師名
                        </div>
                        <div className='item'>
                          {input?.doctor?.lastname} {input?.doctor?.firstname}
                        </div>
                      </>
                    )
                  }

                  {/*carCommuteStartDate*/}
                  <div className='item text-bold'>マイカー通勤開始日</div>
                  <div className='item'>
                    <DatePicker
                      style={{ minWidth: '215.16px' }}
                      className='date-picker mx-2'
                      placeholder={i18n.t(
                        'doctor.myCarCommutingApplication.selectDate'
                      )}
                      locale={locale}
                      value={
                        values.carCommuteStartDate ? moment(values.carCommuteStartDate) : null
                      }
                      onChange={e => {
                        setFieldValue('carCommuteStartDate', e ? e.toDate() : null)
                      }}
                      allowClear={false}
                    />
                    <ErrorMessage
                      name='carCommuteStartDate'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/* frontSideLicenseKey */}
                  <div className='item text-bold'>運転免許証（表）</div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <MyCarCommutingApplicationItem
                      filename={'frontSideLicenseKey'}
                      setFieldValue={setFieldValue}
                      keyValue={values.frontSideLicenseKey}
                    />
                    <ErrorMessage
                      name='frontSideLicenseKey'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/* backSideLicenseKey */}
                  <div className='item text-bold'>運転免許証（裏）</div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <MyCarCommutingApplicationItem
                      setFieldValue={setFieldValue}
                      filename={'backSideLicenseKey'}
                      keyValue={values.backSideLicenseKey}
                    />
                    <ErrorMessage
                      name='backSideLicenseKey'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*expirationDate*/}
                  <div className='item text-bold'>運転免許証有効期限</div>
                  <div className='item'>
                      <DatePicker
                        style={{ minWidth: '215.16px' }}
                        className='date-picker mx-2'
                        placeholder={i18n.t(
                          'doctor.myCarCommutingApplication.selectDate'
                        )}
                        locale={locale}
                        value={
                          values.expirationDate ? moment(values.expirationDate) : null
                        }
                        disabledDate={disabledPastDate}
                        onChange={e => {
                          setFieldValue('expirationDate', e ? e.toDate() : null)
                        }}
                        allowClear={false}
                      />
                      <ErrorMessage
                        name='expirationDate'
                        component='div'
                        className='signup-alert'
                      />
                  </div>

                  {/*vehicleInspectionCertificateKey*/}
                  <div className='item text-bold'>
                    車検証 または 自動車検査証記録事項（有効期限の記載があるもの）
                  </div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <MyCarCommutingApplicationItem
                      setFieldValue={setFieldValue}
                      filename={'vehicleInspectionCertificateKey'}
                      keyValue={values.vehicleInspectionCertificateKey}
                    />
                    <ErrorMessage
                      name='vehicleInspectionCertificateKey'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*vehicleInspectionExpirationDate*/}
                  <div className='item text-bold'>車検証 または 自動車検査証記録事項に記載されている有効期限</div>
                  <div className='item'>
                    <DatePicker
                      style={{ minWidth: '215.16px' }}
                      className='date-picker mx-2'
                      placeholder={i18n.t(
                        'doctor.myCarCommutingApplication.selectDate'
                      )}
                      locale={locale}
                      value={
                        values.vehicleInspectionExpirationDate ? moment(values.vehicleInspectionExpirationDate) : null
                      }
                      disabledDate={disabledPastDate}
                      onChange={e => {
                        setFieldValue('vehicleInspectionExpirationDate', e ? e.toDate() : null)
                      }}
                      allowClear={false}
                    />
                    <ErrorMessage
                      name='vehicleInspectionExpirationDate'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*liabilityInsuranceCertificateKey*/}
                  <div className='item text-bold'>
                    自賠責保険証明書
                  </div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <MyCarCommutingApplicationItem
                      setFieldValue={setFieldValue}
                      filename={'liabilityInsuranceCertificateKey'}
                      keyValue={values.liabilityInsuranceCertificateKey}
                    />
                    <ErrorMessage
                      name='liabilityInsuranceCertificateKey'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*liabilityInsuranceCertificateExpirationDate*/}
                  <div className='item text-bold'>自賠責保険有効期限</div>
                  <div className='item'>
                    <DatePicker
                      style={{ minWidth: '215.16px' }}
                      className='date-picker mx-2'
                      placeholder={i18n.t(
                        'doctor.myCarCommutingApplication.selectDate'
                      )}
                      locale={locale}
                      value={
                        values.liabilityInsuranceCertificateExpirationDate ? moment(values.liabilityInsuranceCertificateExpirationDate) : null
                      }
                      onChange={e => {
                        setFieldValue('liabilityInsuranceCertificateExpirationDate', e ? e.toDate() : null)
                      }}
                      allowClear={false}
                    />
                    <ErrorMessage
                      name='liabilityInsuranceCertificateExpirationDate'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*vehicleType*/}
                  <div className='item text-bold'> 車種名</div>
                  <div className='item'>
                       <InputText
                         value={values.vehicleType}
                         onChange={e => setFieldValue('vehicleType', e.target.value)}
                         placeholder={i18n.t(
                           'doctor.myCarCommutingApplication.vehicleTypePlaceholder'
                         )}
                         style={{ width: '215.16px' }}
                       />
                       <ErrorMessage
                         name='vehicleType'
                         component='div'
                         className='signup-alert'
                       />
                  </div>

                  {/*licensePlateNumber*/}
                  <div className='item text-bold'> ナンバープレート番号</div>
                  <div className='item'>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        gap: '5px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <InputText
                        value={values.licensePlateNumberPart1}
                        onChange={e =>
                          setFieldValue('licensePlateNumberPart1', e.target.value)
                        }
                        placeholder={'例：東京'}
                        style={{ width: '80px' }}
                      />

                      <InputText
                        value={values.licensePlateNumberPart2}
                        onChange={e =>
                          setFieldValue('licensePlateNumberPart2', e.target.value)
                        }
                        placeholder={'例：30X'}
                        style={{ width: '80px' }}
                      />

                      <InputText
                        value={values.licensePlateNumberPart3}
                        onChange={e =>
                          setFieldValue('licensePlateNumberPart3', e.target.value)
                        }
                        placeholder={'例：あ'}
                        style={{ width: '80px' }}
                      />

                      <InputText
                        value={values.licensePlateNumberPart4}
                        onChange={e =>
                          setFieldValue('licensePlateNumberPart4', e.target.value)
                        }
                        placeholder={'例：22'}
                        style={{ width: '80px' }}
                      />
                      <ErrorMessage
                        name='vehicleNumber'
                        component='div'
                        style={{ width: '100%' }}
                        className='signup-alert'
                      />
                    </div>
                  </div>

                  {/*voluntaryInsuranceCertificateKey*/}
                  <div className='item text-bold'>
                    任意保険加入証明書
                  </div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <MyCarCommutingApplicationItem
                      setFieldValue={setFieldValue}
                      filename={'voluntaryInsuranceCertificateKey'}
                      keyValue={values?.voluntaryInsuranceCertificateKey}
                    />
                    <ErrorMessage
                      name='voluntaryInsuranceCertificateKey'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  {/*voluntaryInsuranceCertificateExpirationDate*/}
                  <div className='item text-bold'>任意保険有効期限</div>
                  <div className='item'>
                    <DatePicker
                      style={{ minWidth: '215.16px' }}
                      className='date-picker mx-2'
                      placeholder={i18n.t(
                        'doctor.myCarCommutingApplication.selectDate'
                      )}
                      locale={locale}
                      value={
                        values.voluntaryInsuranceCertificateExpirationDate ? moment(values.voluntaryInsuranceCertificateExpirationDate) : null
                      }
                      onChange={e => {
                        setFieldValue('voluntaryInsuranceCertificateExpirationDate', e ? e.toDate() : null)
                      }}
                      allowClear={false}
                    />
                    <ErrorMessage
                      name='voluntaryInsuranceCertificateExpirationDate'
                      component='div'
                      className='signup-alert'
                    />
                  </div>

                  <div className='item text-bold'></div>
                    <div style={{display: 'flex'}}>
                      <Checkbox
                        checked={values.isAllowSendMailConfirm}
                        onChange={e =>
                          setFieldValue('isAllowSendMailConfirm', e.target.checked)
                        }
                      />
                      <p style={{ marginLeft: 10, marginBottom: 0 }}>
                        承認メールを送信しない
                      </p>
                    </div>
                </div>

                {/* action */}
                <div
                  style={{
                    gap: '1rem',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '2rem',
                  }}
                >
                  {
                    values.id !== '' && <Button
                      className='cancel-button btn'
                      onClick={() => {
                        setFieldValue('confirm', true)
                        setFieldValue('type', 'resend')
                      }}
                      type='button'
                      disabled={isSubmitting}
                      label={i18n.t('staff.detailDoctorIdentity.resendRequest')}
                    />
                  }
                  <Button
                    className='reflect-button btn'
                    onClick={ () => {
                      validateForm().then(errors => {
                        if (!Object.keys(errors).length) {
                          // React 18 では反映が後回しになり、送信前のチェックがキャンセルされて送信が止まる。すぐ反映する（#386）
                          flushSync(() => setFieldValue('type', 'approve'))
                          handleSubmit()
                        } else {
                          const touched = Object.keys(errors).reduce(
                            (acc, key) => ({ ...acc, [key]: true }),
                            {}
                          )
                          setTouched(touched)
                        }
                      })
                    }}
                    disabled={isSubmitting}
                    type='button'
                    label={i18n.t('staff.movingExpensesOtherDetail.btnApprove')}
                  />
                     <Button
                      className='reflect-button btn'
                      onClick={ () => {
                        validateForm().then(errors => {
                          if (!Object.keys(errors).length) {
                            // React 18 では反映が後回しになり、送信前のチェックがキャンセルされて送信が止まる。すぐ反映する（#386）
                            flushSync(() => setFieldValue('type', 'first-check'))
                            handleSubmit()
                          } else {
                            const touched = Object.keys(errors).reduce(
                              (acc, key) => ({ ...acc, [key]: true }),
                              {}
                            )
                            setTouched(touched)
                          }
                        })
                      }}
                      disabled={
                       isSubmitting ||
                        (input?.approvalStatus !== 'WAITING_FOR_APPROVAL' && input?.approvalStatus  !== 'RESUBMIT_REQUEST')}
                      type='button'
                      label={i18n.t('staff.movingExpensesOtherDetail.firstCheck')}
                    />
                </div>
              </div>
              {/* RESEND FORM MODAL */}
              <ConfirmationModalResendForm
                {...formikProps}
                blockSubmit={!values.msg}
                isSubmitting={isSubmitting}
                handleSubmit={async () => {
                  if (!values.msg) {
                    setFieldError('msg', 'required')
                    return
                  }

                  onSubmit(values, formikProps)
                }}
                handleNoClick={() => {
                  setFieldValue('confirm', false)
                  setFieldValue('msg', '')
                }}
                mainHeader={'マイカー申請再提出依頼コメント'}
                footerClassName={'my-car-commuting-info-footer-content'}
                visibleKey='confirm'
              >
                <div>
                  <div className='th'>{i18n.t('main.resendReason')}</div>
                  <InputTextarea {...formikProps} name='msg' myNumberDetail />
                </div>
              </ConfirmationModalResendForm>
              {/* UPLOAD FILE MODAL */}
              <ConfirmationModal
                headerContent={'書類提出'}
                handleNoClick={() => {
                  setFieldValue('uploadModal', false)
                  setFieldValue('currentUploadField', '')
                }}
                values={values}
                visibleKey={'uploadModal'}
                hideFooter={true}
              >
                {
                  values.currentUploadField !== '' && <>
                    <UploadIdentity
                      i18n={i18n}
                      values={values}
                      fieldValue={values.currentUploadField}
                      setFieldValue={setFieldValue}
                      downloadFileSubmit={downloadFileSubmit2}
                      imgKey={values[values.currentUploadField]}
                    />
                  </>
                }
              </ConfirmationModal>
            </React.Fragment>
          )
        }}
      />
    </>
  )
}
